import { render } from "./MemberRolePicker.vue?vue&type=template&id=de9ecb00&scoped=true"
import script from "./MemberRolePicker.vue?vue&type=script&lang=js"
export * from "./MemberRolePicker.vue?vue&type=script&lang=js"

import "./MemberRolePicker.vue?vue&type=style&index=0&id=de9ecb00&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-de9ecb00"

export default script